/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/virtual_columns.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    virtualColumnsModule
} from "../../../grids/grid_core/virtual_columns/m_virtual_columns";
import gridCore from "../m_core";
gridCore.registerModule("virtualColumns", virtualColumnsModule);
